const IGNORED_KEYS = new Set([
  // Modifier keys
  "Control",
  "Alt",
  "Meta",
  "Shift",
  "CapsLock",
  "NumLock",
  "ScrollLock",
  "Dead",
  "Unidentified",
  // Core navigation / activation (keyboard users & screen readers)
  "Tab",
  "Enter",
  " ", // Spacebar
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Escape",
  "Home",
  "End",
  "PageUp",
  "PageDown",
  // Function keys (screen reader / system shortcuts)
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  // OS-level keys
  "OS",
  "Win",
]);

function isInteractiveTarget(el) {
  if (!el) return false;
  const tag = el.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  if (el.isContentEditable) return true;
  const role = el.getAttribute("role");
  if (role === "searchbox" || role === "combobox" || role === "textbox")
    return true;
  return false;
}

export function initKonamiListener(onActivate) {
  // fired resets on each navigation via resetFired()
  let fired = false;

  function handler(e) {
    // Ignore browser shortcuts (Ctrl+F, Cmd+F, etc.)
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    // Ignore modifier-only presses
    if (IGNORED_KEYS.has(e.key)) return;
    // Ignore when focus is inside an interactive text element
    if (isInteractiveTarget(document.activeElement)) return;
    if (fired) return;
    fired = true;
    onActivate();
  }

  function resetFired() {
    fired = false;
  }

  window.addEventListener("keydown", handler);

  return {
    destroy: () => window.removeEventListener("keydown", handler),
    reset: resetFired,
  };
}
